
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BbsDialog from '@/components/BbsDialog/index.vue';
import EditDialogHandUp from '@/components/EditDialog/index.vue';

import { ComplaintModule } from '@/store/modules/complaint';
import { complain } from '@/api/orderComplaint';
import { chargePrice, delOrderService, orderServiceOrderClose, orderServiceOrderHang } from '@/api/orderService';
import { UserModule } from '@/store/modules/user';
import { EditDialog } from '@/types/editDialogType';
import {
  checkPermissionCompanyFromOrderType,
  checkPermissionRole,
  getModelPermission,
  checkServerAppointmentTimeIsMust,
  checkPermissionUseAndCompany,
} from '@/utils/permission';

import { ModuleType, ViewType, Type } from '@/types/permissionType';

@Component({
  name: 'OrderTopTitle',
  components: {
    BbsDialog,
    EditDialogHandUp
  },

})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })isTransferOut!:any;
  @Prop({
    type: Boolean,
    default: true
  })isShowDeal!:any;
  //此参数比较乱 通过查询 目前维修单传的是11 任务过来传的是31 报修单过来是21
  @Prop({
    type: Number,
    default: 11
  })OrderType!:any;
  @Prop({
    type: Array,
    default: () => []
  })tabList!:any;
  @Prop({
    type: Array,
    default: () => []
  })topButtonList!:any;
  @Prop({
    type: Boolean,
    default: false
  })isDetail!:any;
  @Prop({
    type: Boolean,
    default: false
  })confirmButton!:any;

  @Prop({
    type: Object,
    default: () => ({
      order: {},
      order_service: {}
    })
  })orderDetail!:any;

  @Prop({
    type: Object,
    default: () => ({}),
    required: true
  })
  DetailsDataQuery?: any;

  private companyName:any = '';
  private showDropdown:boolean=false;
  private orderServiceId = '';
  private viewType:number=-1
  private bbsViewType=0;

  private all:any=0;

   @Watch('topButtonList', {
     deep: true,
     immediate: true
   })
  topButtonListChangeProps(newVal:any) {
    let arr = newVal.filter((b:any) => {
      return b.show;
    })
    if (arr && arr.length > 0) {
      this.showDropdown = true;
    } else {
      this.showDropdown = false;
    }
  }
  //计算属性
  get transPermission(){
    return checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.ORDER_TRANSFER, this.orderDetail.order.order_type) &&
              checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.ORDER_TRANSFER);
  }
  get enquiryPermission(){
    return checkPermissionCompanyFromOrderType(this.orderDetail.order_service.servicer_company_id, Type.OrderEnquiry, this.orderDetail.order.order_type) &&
              checkPermissionRole(this.orderDetail.order_service.servicer_company_id, Type.OrderEnquiry);
  }
   created() {
     this.companyName = this.$route.query.order_service_id as any;
     this.orderServiceId = this.$route.query.order_service_id as any;
     this.viewType = parseInt(this.$route.query.viewType as string);
     this.all = this.$route.query.all;
     if (this.DetailsDataQuery.order_service_id) {
       this.companyName = this.DetailsDataQuery.order_service_id as any;
       this.orderServiceId = this.DetailsDataQuery.order_service_id as any;
       this.viewType = parseInt(this.DetailsDataQuery.viewType as string);
     }
     if (this.OrderType === 21) {
       this.bbsViewType = 0
     } else {
       this.bbsViewType = 1
     }
   }
   private getTagsHtml(r: any) {
     let kind = "";
     let kindType = "";
     let abnormal = "";
     let plain = "plain";
     if (parseInt(r.order.order_type) === 1) {
       kind = "其他";
       kindType = "warning";
     } else if (parseInt(r.order.order_type) === 2) {
       kind = "维保";
       kindType = "success";
     } else if (parseInt(r.order.order_type) === 3) {
       kind = "安装";
       kindType = "danger";
     } else if (parseInt(r.order.order_type) === 4) {
       kind = "巡检";
       kindType = "";
       if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
         abnormal = "巡异";
       }
     } else {
       kind = "维保";
       kindType = "success";
     }

     let source = "";
     if (r.order.customer_company_id === r.order_service.servicer_company_id) {
       source = "内部";
     } else {
       source = "外部";
     }

     if (parseInt(r.order_service.transfer_in) === 1) {
       source = "转入";
     }
     if (parseInt(r.order_service.transfer_out) === 1) {
       source = "转出";
     }
     //20231114 如果是报修单 不显示source
     if(this.OrderType === 21 ){
      source = "";
     }

     let charge = "";
     let darkplain = "dark";
     if (parseInt(r.order_service.charge) === 1) {
       charge = "收费";
     }

     let expedited = "";
     if (parseInt(r.order_service.expedited) === 1) {
       expedited = "加急";
     }

     // 2019-05-23 迭代 订单排位
     let ranking = "";
     if (parseInt(r.order_service.is_ranking) === 1) {
       let rankingNum = parseInt(r.order_service.ranking);
       if (rankingNum) {
         ranking = rankingNum + "号";
       }
     }

     // 审核标识
     let check = "";
     if (
       parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
     ) {
       check = "审核";
     }

     // 留言
     let mesg = "";
     if (r.order.new_bbs_content && r.order.new_bbs_content.id) {
       mesg = "have";
     }

     if (r.order.is_new_bbs) {
       mesg = "new";
     }

     let urgent = ''
     if (r.order.reminder && parseInt(r.order.reminder.count) > 0) {
       urgent = '已催单' + r.order.reminder.count + '次'
     }

     return [
       {
         type: "",
         label: source,
         plain: darkplain,
       },
       {
         type: kindType,
         label: kind,
         plain: plain,
       },
       {
         type: "danger",
         label: abnormal,
         plain: darkplain,
       },
       {
         type: "danger",
         label: charge,
         plain: darkplain,
       },
       {
         type: "danger",
         label: expedited,
         plain: darkplain,
       },
       {
         type: "danger",
         label: ranking,
         plain: darkplain,
       },
       {
         type: "warning",
         label: check,
         plain: darkplain,
       }, {
         type: "warning",
         label: urgent,
         plain: plain,
       }
     ];
   }
  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  // 不根据state判断，所以永远置为1
  private state: number = 1;
  private complaintState:number = -1;
  // 留言
  private bbsHandle(r: any, isComplaint:any) {
    this.complainDialogVisible = false;
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.bbsDialogVisible = true;
    if (isComplaint) {
      if (this.OrderType === 11 && parseInt(this.orderDetail.order_service.complaint_state) === 2) {
        const params = {
          order_id: this.nowId,
          order_service_id: this.nowSid,
          // 点开，状态设置为5
          complaint_state: 5
        };
        complain(params)
          .then((res) => {
            this.complaintState = 5;
          })
          .catch(() => {
          });
      } else {
        this.state = this.$route.query.all === '1' ? 88 : parseInt(this.orderDetail.order.state)
        this.complaintState = parseInt(this.orderDetail.order_service.complaint_state);
      }
    } else {
      if (this.OrderType === 21) {
        this.state = this.$route.query.all === '1' ? 88 : parseInt(this.orderDetail.order.state)
      }
      this.complaintState = -1
    }
  }
  private closeBbs(value: boolean) {
    this.bbsDialogVisible = value;
  }
  // 投诉
  private complainDialogVisible = false;
  private handleShowComplain() {
    const detail = this.orderDetail as any;
    const state = parseInt(detail.order_service.complaint_state);
    if ([0, 8].includes(state)) {
      this.complainDialogVisible = true;
    } else {
      this.bbsHandle(this.orderDetail, true);
    }
  }
  private handleComplain() {
    const detail = this.orderDetail;
    const params = {
      order_id: detail.order.id,
      order_service_id: detail.order_service.id,
      // 第一次投诉，状态设置为2
      complaint_state: 2,
      company_name: detail.order_service.servicer_company_name,
      order_num: detail.order.order_num
    };
    complain(params).then(res => {
      const item = {
        id: parseInt(detail.order.id),
        stage: 2
      };
      ComplaintModule.switchStage(item);
      this.bbsHandle(this.orderDetail, true);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private companyTabClick(val:any) {
    this.$emit('companyTabClick', this.companyName)
  }
  private sendOrderToHandle(type:string) {
    this.$emit('sendOrderToHandle', type)
  }
  private customerConfirm() {
    this.$emit('customerConfirm')
  }
  // 维修单
  private editDialogData: any = {
    visible: false,
    title: '',
    name: '',
    inputValue: '',
    inputHint: '',
    cancel: '',
    confirm: '',
    callBack: '',
    rules: []
  };
  private buttonClick(button:any) {
    switch (parseInt(button.id)) {
      case 1:
        this.editDialogData = {
          visible: true,
          title: '挂单原因',
          name: '备注',
          inputValue: '',
          inputHint: '请填写挂单原因',
          cancel: '取消',
          confirm: '确定',
          callBack: 'handUpCallBack',
          rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
        };
        // 挂单
        break;
      case 2:
        this.customerConfirm()
        // 代客
        break;
      case 3:
        this.editDialogData = {
          visible: true,
          title: '关闭订单',
          name: '备注',
          inputValue: '',
          inputHint: '请填写备注',
          cancel: '取消',
          confirm: '确定',
          callBack: 'closeOrderCallBack',
          rules: [{ required: true, message: '请填写备注', trigger: 'blur' }]
        };
        // 关闭
        break;
      case 4:
        this.$router.push({
          path: '/OrderServicer/returnvisit',
          query: { orderDetail: JSON.stringify(this.orderDetail) }
        });
        // 回访
        break;
      case 5:
        this.delOrder()
        // 删除
        break;
      case 6:
        // 评价
        break;
      case 7:
        // 添加金额
        this.addPrice(this.orderDetail)
        break;
      case 8:
        // 投诉
        this.bbsHandle(this.orderDetail, true)
        break
    }
  }
// 添加金额
private priceVisible: boolean = false;
private addPirceCustomer='0';
private addPirceSS='';
private addPrice(val:any) {
  this.priceVisible = true;
  this.addPirceCustomer = val.order_service.estimated_amount;
  this.addPirceSS = val.order_service.real_price;
}

private addPriceConfirm() {
  const params = {
    user_id: UserModule.getUserId,
    user_name: UserModule.getUserName,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
    id: (this.orderDetail as any).order_service.id,
    price: this.addPirceSS
  };
  chargePrice(params)
    .then((res: any) => {
      this.priceVisible = false;
      this.showSuccessMsg('修改成功');
      this.$emit('refreshList', true);
    })
    .catch((err: any) => {
      let msg = err.msg;
    });
}

private addPriceClose() {
  this.priceVisible = false;
}
// 挂单返回监听
private handUpCallBack(editDialogData: EditDialog) {
  if (!editDialogData.inputValue.trim()) {
    this.showSuccessMsg('请填写挂单原因');
    return;
  }
  const params = {
    user_id: UserModule.getUserId,
    user_name: UserModule.getUserName,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
    order_service_id: (this.orderDetail as any).order_service.id,
    remark: editDialogData.inputValue
  };
  orderServiceOrderHang(params)
    .then((res: any) => {
      editDialogData.visible = false;
      this.showSuccessMsg('挂单成功');
      this.$router.go(-1)
    })
    .catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
}
// 关单返回监听
closeOrderCallBack(editDialogData: EditDialog) {
  if (!editDialogData.inputValue.trim()) {
    this.showSuccessMsg('请填写备注');
    return;
  }
  const params = {
    user_id: UserModule.getUserId,
    user_name: UserModule.getUserName,
    company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
    order_service_id: this.orderDetail.order_service.id,
    remark: editDialogData.inputValue
  };
  orderServiceOrderClose(params)
    .then((res: any) => {
      editDialogData.visible = false;
      this.showSuccessMsg('关闭成功');
      this.$router.go(-1)
    })
    .catch((err: any) => {
      let msg = err.msg;
    });
}
// 删除
private delOrder() {
  this.$confirm('关联任务会一起删除呦~', '确认删除此订单?', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      let pamars:any = {
        user_id: UserModule.getUserId,
        user_name: UserModule.getUserName,
        company_id: UserModule.getCompanyId,
        company_name: UserModule.getCompanyName
      };
      pamars.order_service_id = this.orderDetail.order_service.id;
      delOrderService(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.$router.go(-1)
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    })
    .catch(() => {});
}
private showErrorMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'error'
  });
}
private showSuccessMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'success'
  });
}
}
